<template>
  <div class="p-grid">
    <div class="p-col-12 p-md-6 p-lg-3">
      <AppWidgetCount
        title="Bovinos"
        subtitle="Total cadastrado no sistema"
        :value="stats.bovine.count"
        valueColor="black"
        valueBackgroundColor="#F7F7F7"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <AppWidgetCount
        title="Lotes/Piquetes"
        subtitle="Total cadastrado no sistema"
        :value="stats.farmLot.count"
        valueColor="#FFF"
        valueBackgroundColor="#5EBD4A"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <AppWidgetCount
        title="Fazendas"
        subtitle="Total cadastrado no sistema"
        :value="stats.farm.count"
        valueColor="#FFF"
        valueBackgroundColor="#89A3E7"
        :loading="loading"
      />
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <AppWidgetCount
        title="Serviços"
        subtitle="Total cadastrado no sistema"
        :value="stats.service.count"
        valueColor="#FFF"
        valueBackgroundColor="#E78989"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { ReportApi } from '../../../services/api';

export default {
  data() {
    return {
      stats: {
        bovine: { count: 0 },
        farmLot: { count: 0 },
        farm: { count: 0 },
        service: { count: 0 },
      },
      loading: false,
    };
  },
  async created() {
    try {
      this.loading = true;
      const data = await ReportApi.getAllCount();
      this.stats = data;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
</style>
